<ng-template let-entity="entity" #actionsTemplate>
  <div class="btn-group" role="group" aria-label="Basic example">
    <button [routerLink]="['edit', entity.getPrimaryKey()]" [queryParams]="{sort: sortParam}"
      class="btn btn-sm btn-outline-dark" ngbTooltip="Ladestation bearbeiten"
      i18n-ngbTooltip="@@EditChargingStationTooltip" placement="left">
      <span data-bs-toggle="modal" data-bs-target="#stationEdit">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-edit">
          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
        </svg>
      </span>
    </button>

    <button [routerLink]="['restart', entity.getPrimaryKey()]" [queryParams]="{sort: sortParam}"
      [disabled]="entity?.status.id == 11 || entity?.status.id == 1" class="btn btn-sm btn-outline-warning"
      ngbTooltip="Ladestation neustarten" i18n-ngbTooltip="@@RestartChargingStationTooltip" placement="left">
      <span data-bs-toggle="modal" data-bs-target="#stationDelete">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-refresh-cw">
          <polyline points="23 4 23 10 17 10"></polyline>
          <polyline points="1 20 1 14 7 14"></polyline>
          <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
        </svg>
      </span>
    </button>

    <button [routerLink]="['delete', entity.getPrimaryKey()]" [queryParams]="{sort: sortParam}"
      class="btn btn-sm btn-outline-danger" ngbTooltip="Ladestation löschen"
      i18n-ngbTooltip="@@DeleteChargingStationTooltip" placement="left">
      <span data-bs-toggle="modal" data-bs-target="#stationDelete">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="feather feather-trash">
          <polyline points="3 6 5 6 21 6"></polyline>
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
        </svg>
      </span>
    </button>
  </div>
</ng-template>

<ng-template #customerView>

  <div class="clearfix">
    <form class="float-start">
      <div i18n="@@Search" style="min-width:200px;">
        <input class="form-control" id="table_search" type="text" name="searchTerm"
          [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
      </div>
    </form>

    <span class="float-end mb-1">

      <button class="btn btn-yellow me-2" [routerLink]="['create']"
        *ngIf="operator && config?.isAddButtonVisible || isProduction" id="add_chargingstation"
        [disabled]="entities?.length >= permissions?.chargingstationsCreate || isSupporter" data-bs-placement="left">
        <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
        <span class="d-none d-md-inline ps-2" i18n="@@AddChargingStationButton">Ladestation hinzufügen</span>
      </button>


      <button class="btn btn-yellow" id="card_list_view_toggle"
        (click)="tableFunctions.toggleTableLayout(className, className + 'Table', $event.target)"
        [innerHTML]="sanitizer.bypassSecurityTrustHtml(tableFunctions.getTableLayoutCaption(className))">
      </button>
    </span>
  </div>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-template>

<ng-template #operatorView>
  <div class="clearfix">
    <form class="float-start">
      <div i18n="@@Search" style="min-width:200px;">
        <input class="form-control" id="table_search" type="text" name="searchTerm"
          [(ngModel)]="tableFunctions.searchTerm" i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
      </div>
    </form>
    <div class="float-end">
      <div ngbDropdown class="d-inline-block" *ngIf="!this.user && !isSupporter">
        <button type="button" class="btn btn-warning" id="dropdownBasic2" ngbDropdownToggle>
          <app-svg source="icons/feather/settings" height="18"></app-svg>
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic2"
             style="padding:0 !important;width:auto !important;min-width:0.125em !important">
          <button class="btn btn-yellow mb-1" (click)="PushEVSEData()" id="PushEVSEData"
                  ngbTooltip="Synchronisiert Informationen von allen Hubject-kompatiblen Ladestationen mit Hubject."
                  i18n-ngbTooltip="@@PushEVSEDataTooltip" placement="left right">
            <app-svg source="icons/feather/upload-cloud" height="18"></app-svg><br />
            <span class="d-none d-md-inline ps-2" i18n="@@PushEVSEData">Hubject Daten senden</span>
          </button>
          <button class="btn btn-yellow mb-1" (click)="PushEVSEStatus()" id="PushEVSEStatus"
                  ngbTooltip="Synchronisiert den Status von allen Hubject-kompatiblen Ladestationen mit Hubject."
                  i18n-ngbTooltip="@@PushEVSEDataTooltip" placement="left right">
            <app-svg source="icons/feather/refresh-cw" height="18"></app-svg><br />
            <span class="d-none d-md-inline ps-2" i18n="@@PushEVSEStatus">Hubject Status senden</span>
          </button>
          <button class="btn btn-yellow mb-1" [routerLink]="['/blackboxes/setup']" id="add_blackbox"
                  ngbTooltip="Assistenten zum Anlegen einer neuen Blackbox aufrufen."
                  i18n-ngbTooltip="@@AddChargingStationTooltip" placement="left right">
            <app-svg source="icons/feather/plus-circle" height="18"></app-svg><br />
            <span class="d-none d-md-inline ps-2" i18n="@@AddBlackBoxButton">Blackbox einrichten</span>
          </button>
          <button class="btn btn-yellow" [routerLink]="['create']" *ngIf="config?.isAddButtonVisible"
                  id="add_chargingstation" ngbTooltip="Dialog zum Anlegen einer neuen Ladestation aufrufen."
                  i18n-ngbTooltip="@@AddChargingStationTooltip" placement="left right">
            <app-svg source="icons/feather/plus-circle" height="18"></app-svg><br />
            <span class="d-none d-md-inline ps-2" i18n="@@AddChargingStationButton">Ladestation hinzufügen</span>
          </button>
          <!--<button class="btn btn-yellow" [routerLink]="['assistent']" *ngIf="config?.isAddButtonVisible"
                  id="add_chargingstation" ngbTooltip="Assistenten zum Anlegen einer neuen Ladestation aufrufen."
                  i18n-ngbTooltip="@@AddChargingStationTooltip" placement="left right">
            <app-svg source="icons/feather/rss" height="18"></app-svg><br />
            <span class="d-none d-md-inline ps-2" i18n="@@AddChargingStationButton">Ladepunkt Assistent</span>
          </button>-->
          <!--<button class="btn btn-yellow d-none" (click)="checkChargingStationStatus()" *ngIf="config?.isAddButtonVisible" id="check_chargingstation" ngbTooltip="Prüft ob die Ladestationen erreichbar sind. Wenn nicht wird der Status aktualisiert." i18n-ngbTooltip="@@CheckChargingStationTooltip" placement="left right">
    <app-svg source="icons/feather/plus-circle" height="18"></app-svg>
    <span class="d-none d-md-inline ps-2" i18n="@@AddChargingStationButton">Erreichbarkeit prüfen</span>
  </button>-->
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngTemplateOutlet="opcontent"></ng-container>
</ng-template>

<ng-template #opcontent>

  <div *ngIf="tableReady" [class]="tableView">
    <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()" class="table-layout"></app-table>
  </div>

  <div *ngIf="!tableReady" class="loading-spinner-container">
    <div class="spinner-border text-primary loading-spinner-md" role="status">
      <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
    </div>
  </div>
</ng-template>

<ng-template #content>
  <div *ngIf="tableReady" [class]="tableView">
    <app-table [id]="className + 'Table'" [table]="table" (sorted)="onSort()"
      [class]="tableFunctions.getTableLayout(className)"></app-table>
  </div>

  <div *ngIf="!tableReady" class="loading-spinner-container">
    <div class="spinner-border text-primary loading-spinner-md" role="status">
      <span class="visually-hidden-focusable" i18n="@@LoadingMessage">Loading...</span>
    </div>
  </div>
</ng-template>


<ng-template #userView>
  <div class="clearfix">
    <form class="float-start">
      <div i18n="@@Search" style="min-width:200px;">
        <input class="form-control" id="table_search" type="text" name="searchTerm" [(ngModel)]="tableFunctions.searchTerm"
          i18n-placeholder="@@SearchAll" placeholder="Alles durchsuchen..." />
      </div>
    </form>
    <span class="float-end mb-1">
      <button class="btn btn-yellow ms-1" id="card_list_view_toggle"
        (click)="tableFunctions.toggleTableLayout(className, className + 'Table', $event.target)"
        [innerHTML]="sanitizer.bypassSecurityTrustHtml(tableFunctions.getTableLayoutCaption(className))">
      </button>
    </span>
  </div>
  <ng-container *ngTemplateOutlet="content"></ng-container>

</ng-template>

<ng-container *ngTemplateOutlet="determineTemplate()"></ng-container>

<router-outlet></router-outlet>
